import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import { useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { Switch } from "@mui/material";

const DeliveryTerms = () => {

    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.deliveryTerms}`;

    const [selectedRows, setSelectedRows] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [error, setError] = useState("")
    const gridRef = useRef();
    const navigate = useNavigate();
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [deleteDisable, setDeleteDisable] = useState(true);
 const [gridApi, setGridApi] = useState(null);
    const IconComponent=(props)=> {
        let bool = props?.data?.isActive
        return <Switch size="small" defaultChecked={bool} disabled />
    }
    
    const [columnDefs, setColumnDefs] = useState([
        { field: 'deliveryTemCode',headerName: 'Delivery Term Code', enableRowGroup: true },
        { field: 'termsOfDelivery', enableRowGroup: true },
        { field: 'isActive', headerName:'Active', enableRowGroup: true, cellRenderer: IconComponent },
    ]);


    const findDeliveryTerms = async () => {
        gridApi?.showLoadingOverlay();
        try {
            const list = await OAuthService.getList(url + `?sort=code,asc&size=1000`);
            const deliveryTerms = list.data?._embedded?.deliveryTermses
            setRowData(deliveryTerms);
        } catch (error) {
            setError(error.message);
        } finally {
    gridApi?.hideOverlay();
  }
    }

    const onGridReady = useCallback((params) => {
       setGridApi(params?.api)
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, []);
       
        useEffect(() => {
               if (gridApi) {
                     findDeliveryTerms();
               }
           }, [gridApi]);

    
    const onBtExport = useCallback(() => {
        const params = {
            fileName: 'DeliveryTerms.xlsx',
            sheetName: 'Delivery Terms'
        }
        gridRef.current.api.exportDataAsExcel(params);
    }, []);

    const handlePurge = (e) => {
        selectedRows.map(async (row) => {
            // var filename = row?._links?.user?.href.split('/').pop()
            try {
                await OAuthService.deleteData(url, row.id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                findDeliveryTerms();
            } catch (error) {
                setError(error.message);
            }
        })
    };

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }

    const onRowDoubleClicked = (params) => {
        navigate('/editDeliveryTerms/' + selectedRows[0].id);
    }

    useEffect(() => {
        if (selectedRows.length > 0) {
            setDeleteDisable(false)
        } else {
            setDeleteDisable(true)
        }
    }, [selectedRows])

    return (
        <>
            <ListPageHeader
                componentName="Delivery Terms"
                onBtExport={onBtExport}
                handlePurge={handlePurge}
                addPageLink="/addDeliveryTerms"
                pageName="Delivery Terms List"
                error={error}
                successMsg={successMsg}
                snackState={snackState}
                deleteDisable={deleteDisable}
                gridRef={gridRef}
            />
            <div className="h-full">
                <AgGridTable
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                    onRowDoubleClicked={onRowDoubleClicked}
                    gridRef={gridRef}
                    paginationPageSize={10}
                    cacheBlockSize={10}
                    saveGridStateName={'deliveryTermsList'}
                />
            </div>
        </>
    )
}

export default DeliveryTerms